import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { TabContext } from "@mui/lab";
import { Divider, Grid2, Tab, TableCell } from "@mui/material";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import CommonButton from "../../../../component/Button";
import SnackBar from "../../../../component/SnackBar";
import { CustomDiv } from "../../../../modules/chat-bot/style";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
  TabPanelView,
} from "../../../../modules/common-components/StyledComponents";
import DialogCandidateHub from "../../../../modules/jobs/jobs-candidate/components/DialogCandidateHub";
import {
  AllPlan,
  PlanBillingCall,
  PlanCancel,
  PlanHistory,
} from "../../../../redux/action/OrganizationSetup";
import { SubscriptionTabList } from "../../style";
import History from "./component/History";
import Plan from "./component/Plan";

export default function PlanBilling() {
  const updatedVersion = process.env.REACT_APP_WEBSITE_URL;
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const tabData = [{ name: "Plans" }, { name: "History" }];
  const [value, setValue] = useState(0);
  const [checked, setChecked] = useState(false);
  const [planData, setPlanData] = useState({ loading: true });
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    disabled: false,
    noLoading: false,
    yesLoading: false,
  });
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const headerData = [
    { name: "Plan" },
    { name: "Billed" },
    { name: "Transaction Id" },
    { name: "End Date" },
    { name: "Status" },
    { name: "Invoice" },
  ];
  const [historyList, setHistoryList] = useState({
    data: [],
    loading: false,
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleClickStripeOpen = async (item, index, checked) => {
    setPlanData((prev) => ({
      ...prev,
      all_plans: prev.all_plans.map((_, i) =>
        i === index ? { ..._, disabled: true, loading: true } : _
      ),
    }));
    if (item.name === "Scale") {
      setTimeout(() => {
        setPlanData((prev) => ({
          ...prev,
          all_plans: prev.all_plans.map((_, i) => ({
            ..._,
            disabled: false,
            loading: false,
          })),
        }));
        window.open(
          `${updatedVersion}/contact-us`,
          "_blank",
          "noopener,noreferrer"
        );
      }, 1000);
    } else {
      try {
        let payload = {
          plan: checked ? item.name + " Yearly" : item.name + " Monthly",
        };
        let data = await PlanBillingCall(payload);
        setPlanData((prev) => ({
          ...prev,
          all_plans: prev.all_plans.map((_, i) => ({
            ..._,
            disabled: false,
            loading: false,
          })),
        }));

        window.open(data?.data?.url, "_blank", "noopener,noreferrer");
      } catch (error) {
        setPlanData((prev) => ({
          ...prev,
          all_plans: prev.all_plans.map((_, i) => ({
            ..._,
            disabled: false,
            loading: false,
          })),
        }));
        setSnackbarState({
          open: true,
          severity: "error",
          message: error?.data?.message || error.message,
        });
      }
    }
  };

  const handleTabChange = (event, newValue) => setValue(newValue);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const functionCall = async () => {
    setPlanData((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      const data = await AllPlan();
      setPlanData({ ...data, loading: false });
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
      setPlanData((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };
  useEffect(() => {
    if (value === 1) {
      handleHistoryCall();
    } else functionCall();
  }, [value]);

  const handleExpand = (value) => {
    setPlanData((prev) => ({
      ...prev,
      all_plans: prev.all_plans.map((item, index) =>
        index === value
          ? {
              ...item,
              expand:
                item.expand === "View Details"
                  ? "Hide Details"
                  : "View Details",
            }
          : item
      ),
    }));
  };

  const handlePlanCancel = () => {
    setStatusDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleStatusClose = () => {
    setStatusDialog({
      open: false,
      disabled: false,
      noLoading: false,
      yesLoading: false,
    });
  };

  const handleStatusChange = async (condition) => {
    if (condition === "no") {
      setStatusDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleStatusClose();
      }, 1000);
    } else if (condition === "yes") {
      setStatusDialog((prev) => ({
        ...prev,
        yesLoading: true,
        disabled: true,
      }));
      try {
        let payload = {
          plan_name: planData?.current_plan?.name,
        };
        const data = await PlanCancel(payload);
        await functionCall();
        setSnackbarState({
          open: true,
          severity: "success",
          message: data.message,
        });
        handleStatusClose();
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setStatusDialog((prev) => ({
          ...prev,
          yesLoading: false,
          disabled: false,
        }));
      }
    }
  };
  const SatusFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={statusDialog.disabled}
        loading={statusDialog.noLoading}
        onClick={() => handleStatusChange("no")}
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={statusDialog.disabled}
        loading={statusDialog.yesLoading}
        onClick={() => handleStatusChange("yes")}
      />
    </CommonGrid2>
  );

  const handleIconClick = (row) => {
    window.open(row.invoice, "_blank", "noopener,noreferrer");
  };
  const handleTableBodyData = (row, index) => {
    return (
      <Fragment>
        <TableCell>{row.plan}</TableCell>
        <TableCell>{row.billed}</TableCell>
        <TableCell>{row.transaction_id}</TableCell>
        <TableCell>{moment(row.end_date).format("MMM DD YYYY")}</TableCell>
        <TableCell>
          <StatusChange>
            <DotColor color={row.status === "Completed" ? "red" : "green"} />
            {row.status}
          </StatusChange>
        </TableCell>
        <TableCell>
          <CommonButton
            value={"View Invoice"}
            padding={"4px 1rem"}
            borderRadius={"5px"}
            fontWeight={600}
            disabled={row.invoice === null}
            onClick={() => handleIconClick(row)}
          />
        </TableCell>
      </Fragment>
    );
  };
  const handleHistoryCall = async () => {
    try {
      setHistoryList((prev) => ({
        ...prev,
        loading: true,
      }));
      let data = await PlanHistory();
      setHistoryList((prev) => ({
        ...prev,
        data: data,
        loading: false,
      }));
    } catch (error) {
      setHistoryList((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message || error.message,
      });
    }
  };

  return (
    <CustomDiv padding={"0rem 1.5rem 1.5rem"}>
      <TabContext value={value}>
        <Grid2 alignItems="center" marginTop={3}>
          <SubscriptionTabList
            onChange={handleTabChange}
            aria-label="create-job"
          >
            {tabData.map((item, index) => (
              <Tab key={index} label={item.name} value={index} />
            ))}
          </SubscriptionTabList>
        </Grid2>

        <Divider />
        <TabPanelView value={0} padding="2rem 0px 0px">
          <Plan
            handleChange={handleChange}
            handleExpand={handleExpand}
            handleClickStripeOpen={handleClickStripeOpen}
            checked={checked}
            planData={planData}
            handlePlanCancel={handlePlanCancel}
            localStorageData={localStorageData}
          />
        </TabPanelView>
        <TabPanelView value={1} padding="1.5rem 0px 0px">
          <History
            headerData={headerData}
            handleTableBodyData={handleTableBodyData}
            historyList={historyList}
          />
        </TabPanelView>
      </TabContext>

      <DialogCandidateHub
        open={statusDialog.open}
        handleButttonClose={handleStatusClose}
        footer={<SatusFooter />}
        title={"Do you want to confirm this"}
        titlepadding={"0.5rem 0px 0.5rem"}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
